import type { ErrorInfo } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';

import { Logger } from '@montugroup/utilities';

import App from './App';
import ErrorFallback from './components/ErrorFallback';
import { FeatureFlagProvider } from './providers/FeatureFlagProvider';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const logger = new Logger('FORMS_APP');
const container = document.getElementById('root');
const root = createRoot(container!);

const logError = (error: Error, info: ErrorInfo) => {
  logger.error(error, info);
};

root.render(
  <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
    <FeatureFlagProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </FeatureFlagProvider>
  </ErrorBoundary>,
);
